import Vue from 'vue';
import { mapGetters, mapActions } from 'vuex';
import { BfSpinner } from 'components/Butterfly';
import { LOAD_ANALYSIS, LOAD_NPS, CLEAR_ANALYSIS_TIMELINE } from 'src/store/types';
export default Vue.extend({
    components: { BfSpinner },
    props: {
        projectId: { type: Number, required: true },
        analysisId: { type: Number, required: true }
    },
    data() {
        return {
            analysisError: null,
            showLoader: true,
            analysisLoadStartTime: null
        };
    },
    computed: {
        ...mapGetters([
            'currentAnalysis',
            'hasNPS',
            'hasSentiment',
            'hasDate',
            'currentModel',
            'currentProject',
            'currentSite',
            'currentUser',
            'featureFlags',
        ])
    },
    mounted() {
        this.fetchAnalysis();
    },
    methods: {
        ...mapActions({ LOAD_ANALYSIS, LOAD_NPS }),
        async fetchAnalysis() {
            // When the route is changed, e.g switching site, the URL params can lag
            // behind the actual location (when called from mounted) and error due to
            // the Site-Name header not matching the project/analysis ID.
            if (window.location.pathname !== this.$route.path) {
                return;
            }
            // First, always clear timeline data
            this.$store.commit(CLEAR_ANALYSIS_TIMELINE);
            try {
                this.analysisLoadStartTime = new Date();
                // Load analysis
                await this.LOAD_ANALYSIS({
                    projectId: this.projectId,
                    analysisId: this.analysisId,
                    rethrowErrors: true
                });
                if (this.hasNPS) {
                    await this.LOAD_NPS({
                        projectId: this.projectId,
                        analysisId: this.analysisId,
                        rethrowErrors: true
                    });
                }
                if (this.currentAnalysis && this.currentModel) {
                    let analysis = this.currentAnalysis;
                    let model = this.currentModel;
                    this.$analytics.track.analysis.home({
                        analysisId: analysis.id,
                        createdAt: analysis.created,
                        modifiedAt: analysis.modified,
                        numConcepts: model.hierarchy_concepts.length,
                        numTerms: model.stats.model_term_count,
                        coveredFrames: model.stats.covered_frames,
                        nonEmptyFrames: model.stats.non_empty_frames,
                        coverage: model.stats.covered_frames / model.stats.non_empty_frames
                    });
                }
            }
            catch (error) {
                this.analysisError = error;
            }
            finally {
                this.delayedLoaderHide();
            }
        },
        delayedLoaderHide() {
            // ensure that loader is shown for at least one second
            const diff = (new Date()).valueOf() - this.analysisLoadStartTime.valueOf();
            const delay = diff > 1000 ? 0 : 1000 - diff;
            setTimeout(() => {
                this.showLoader = false;
            }, delay);
        },
    },
    metaInfo() {
        return {
            title: this.currentAnalysis?.name ? `${this.currentAnalysis.name} Analysis - Kapiche` : null
        };
    },
    watch: {
        '$route': function () {
            this.$el.scrollTop = 0;
        },
        analysisId: function (newId, oldId) {
            if (newId !== oldId) {
                this.showLoader = true;
                this.fetchAnalysis();
            }
        }
    },
});
